import React, { Fragment, useState, useCallback } from 'react';
import TextField from '@material-ui/core/TextField';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { COLORS } from '../../styles/colors';
import { debounce } from 'lodash';
/**
 * Info
 */
function Search(props) {

    const debounceLoadData = useCallback(debounce((term) => {
        props.changeSearch(term)
    }, 1000), []);

    const [search, setSearch] = useState('');
    
    return (<TextField
        type='text'
        label={props.label ? props.label : 'Search' }
        margin="dense"
        variant="outlined"
        value={search}
        onChange={(e) => {
            setSearch(e.target.value);
            debounceLoadData(e.target.value)
        }}
        style={{width: 'auto'}}
        InputProps={{
            endAdornment: (
            <FontAwesomeIcon
                icon="search"
                style={{
                color: COLORS.grey
                }}/>
            ),
        }}
    />);
}

export default Search;



// WEBPACK FOOTER //
// ./src/components/workouts/search.js